import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { startsWith } from 'ramda/es';

@Pipe({
  name: 'friendlyPhone'
})
@Injectable()
export class FriendlyPhonePipe implements PipeTransform {
  // e.g. +33650254578 -> 06 50 25 45 78
  transform(phoneNumber: string): string {
    const withoutPrefix = phoneNumber.slice(startsWith('+', phoneNumber) ? 1 : 0);
    const frenchNumber = startsWith('33', withoutPrefix)
      ? `0${withoutPrefix.slice(2)}`
      : withoutPrefix;
    return frenchNumber.match(/.{2}/g).join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/edit/friendly-phone.pipe.ts